import { FormatPipeline, type PipelineOptions } from '~/utils/formatters/prtials/formatPipeline';

export class TextFormatter {
  public static createPipeline(options: PipelineOptions<string>) {
    return new FormatPipeline<string>(options, TextFormatter);
  }

  // Static formatters

  public static firstLetterUppercase(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  public static splitCamelCase(text: string) {
    return text.replace(/([A-Z])/g, ' $1').trim();
  }

  public static shortenAddress(address: string, length = 4) {
    return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
  }

  public static zeroPrefix(value: string | number, length = 2) {
    return value.toString().padStart(length, '0');
  }

  public static alwaysDefined(value: any, replacer = 'N/A') {
    return value !== undefined && value !== null
      ? Object.hasOwn(value, 'toString')
        ? value.toString()
        : String(value)
      : replacer;
  }

  // Static custom methods

  public static formatLeaderBoardText(text: string | number): string | number {
    const maximum = 100;
    return Number(text) > maximum ? `${maximum}+` : text;
  }

  public static transformNftNameToCamelCase(nftName: string) {
    const splitNftName = nftName.split('-');

    return splitNftName.reduce((previousValue, currentValue) => {
      previousValue += this.firstLetterUppercase(currentValue);
      return previousValue;
    }, '');
  }

  public static formatTranslationKey(key: string) {
    if (!key.includes('-')) return `core${this.firstLetterUppercase(key)}`;

    return `core${this.transformNftNameToCamelCase(key)}`;
  }
}
